import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormLabel,
  FormControl,
  Input,
  FormErrorMessage,
  useToast,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { apiBlog } from '../../../../services/api'

const schema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
})

export function ModalLoginBlog({ isOpen, onOpen, onClose, setUserBlog }) {
  const { handleSubmit, formState, register } = useForm({
    resolver: zodResolver(schema),
  })
  const toast = useToast()

  async function handleLoginOnBlog(data) {
    try {
      const response = await apiBlog.post('/login', {
        email: data.email,
        password: data.password,
      })
      setUserBlog(response.data)
      localStorage.setItem('userBlog', JSON.stringify(response.data))
      onClose()

      toast({
        title: 'Login efetuado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

    } catch (error) {
      console.log(error)
      toast({
        title: 'Erro ao fazer login',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          as="form"
          onSubmit={handleSubmit(handleLoginOnBlog)}
        >
          <ModalHeader>Faça login para criar um post no blog.</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl
              id="email"
              isRequired
              isInvalid={formState.errors.email}
            >
              <FormLabel>Email</FormLabel>
              <Input type="email" 
                {...register('email')}
              />
              <FormErrorMessage>Email incorreto</FormErrorMessage>
            </FormControl>

            <FormControl
              id="password"
              isRequired
              mt={4}
              isInvalid={formState.errors.password}
            >
              <FormLabel>Senha</FormLabel>
              <Input type="password" 
                {...register('password')}
              />
              <FormErrorMessage>Senha incorreta</FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button 
              variant='ghost'
              type="submit"
              isLoading={formState.isSubmitting}
            >Confirmar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}